import React from 'react';

import clsx from 'clsx';
import ErrorIcon from '@material-ui/icons/Error';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { makeStyles } from '@material-ui/core/styles';

const mkErrMsgStyles = makeStyles(theme => ({
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
  },
}));

export default function ErrorMessage(props) {
  const classes = mkErrMsgStyles();
  const msg = props.msg;
  const extra = props.extra;
  return <SnackbarContent
    className={clsx(classes.error)}
    style={{ paddingTop: '0px', paddingBottom: '0px', marginBottom: '5px' }}
    message={
      <span className={classes.message}>
        <ErrorIcon className={clsx(classes.icon, classes.iconVariant)} />
        {msg}
        {!extra ? '' : <br />}
        {!extra ? '' : extra}
      </span>
    }
  />;
}